import * as React from 'react';
import {forwardRef} from 'react';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import { useSearchStore, selectSearchTags } from 'features/search/store/useSearchStore';

interface Props {
    searchString: string;
    onSearchFieldChange: (e:React.ChangeEvent<HTMLInputElement>) => void;
    onSearchFieldFocus: (e:React.FocusEvent<HTMLInputElement>) => void;
    animationTriggered: boolean;
}

export const SearchField = forwardRef<HTMLInputElement, Props>(({searchString, onSearchFieldChange, onSearchFieldFocus, animationTriggered}, ref) => {
    const isMobile = useDeviceStore(selectIsMobile);
    const selectedTags = useSearchStore(selectSearchTags);
    
    const labelClasses = classnames('static-placeholder accessible-placeholder',  {
        'accessible-placeholder--small': !(searchString.length === 0 && selectedTags.length === 0),
        'visually-hidden': selectedTags.length !== 0,
    });
    const wrapperClasses = classnames('search-field__field',  {
        'search-field__field--active': searchString.length !== 0 && selectedTags.length === 0,
    });

    return (
        <div className={wrapperClasses}>
            <form action="." onSubmit={(e:React.FormEvent) => { e.preventDefault() }}>
                <label htmlFor="residence-search" className={labelClasses}>
                    <FormattedMessage id="jm.components.SearchField.searchMessage" />
                </label>
                <input 
                    id="residence-search"
                    type="search"
                    className='search-field__input'
                    ref={ref}
                    onChange={onSearchFieldChange}
                    onFocus={onSearchFieldFocus}
                    value={searchString}
                    spellCheck={false}
                    autoComplete="off"
                    autoCorrect="off" 
                    tabIndex={0}
                />
            </form>

            {searchString.length === 0 && selectedTags.length > 0 && (!isMobile || (isMobile && animationTriggered)) &&
                <div className="static-placeholder">
                    <FormattedMessage id="jm.components.SearchField.searchMore" />
                </div>
            }
        </div>
    );
});
